import './views/index'
import './views/edit'
import './views/show_manager'
